import { Map } from '../twig/pages/template-map';
(new Map()).init();
